module.exports = __webpack_public_path__ + "static/media/DNAborder.c5b53cb2.webp";